"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

exports.__esModule = true;
exports.getArrowShift = exports.detachClasses = exports.createComponentThatRendersItsChildren = exports.buildChildrenObject = exports.attachClasses = void 0;
exports.getParentNode = getParentNode;
exports.getScrollParent = getScrollParent;
exports.shouldAnimatePopover = exports.noop = exports.isStatelessComponent = exports.isReactElement = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isTestEnv = process.env.NODE_ENV === 'test';

function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  } // @ts-ignore


  return element.parentNode || element.host;
}

function getStyleComputedProperty(element) {
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView; // @ts-ignore

  return window.getComputedStyle(element, null);
} // @ts-ignore


function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;

    case '#document':
      // @ts-ignore
      return element.body;

    default:
  } // Firefox want us to check `-x` and `-y` variations as well


  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var buildChildrenObject = function buildChildrenObject(children, childrenObject) {
  return React.Children.toArray(children).reduce(function (acc, child) {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return acc;
    }

    if (!child.type || !child.type.displayName) {
      return acc;
    }

    var name = child.type.displayName.split('.').pop(); // @ts-ignore

    acc[name] = child;
    return acc;
  }, childrenObject || {});
};

exports.buildChildrenObject = buildChildrenObject;

var createComponentThatRendersItsChildren = function createComponentThatRendersItsChildren(displayName) {
  var Element = function Element(_ref) {
    var children = _ref.children;
    return typeof children === 'string' ? /*#__PURE__*/React.createElement('div', {}, children) : children;
  };

  Element.displayName = displayName;
  return Element;
};

exports.createComponentThatRendersItsChildren = createComponentThatRendersItsChildren;

var noop = function noop() {
  return null;
};

exports.noop = noop;

var isReactElement = function isReactElement(child, Element) {
  return child && child.type === Element;
};

exports.isReactElement = isReactElement;

var isStatelessComponent = function isStatelessComponent(Component) {
  return !(Component.prototype && Component.prototype.render);
};

exports.isStatelessComponent = isStatelessComponent;

var attachClasses = function attachClasses(node, classnames) {
  var _node$classList;

  return node && (_node$classList = node.classList).add.apply(_node$classList, (0, _toConsumableArray2["default"])(classnames.split(' ')));
};

exports.attachClasses = attachClasses;

var detachClasses = function detachClasses(node, classnames) {
  var _node$classList2;

  return node && (_node$classList2 = node.classList).remove.apply(_node$classList2, (0, _toConsumableArray2["default"])(classnames.split(' ')));
};

exports.detachClasses = detachClasses;

var shouldAnimatePopover = function shouldAnimatePopover(_ref2) {
  var timeout = _ref2.timeout;

  if ((0, _typeof2["default"])(timeout) === 'object') {
    var enter = timeout.enter,
        exit = timeout.exit;
    return typeof enter !== 'undefined' && typeof exit !== 'undefined' && (enter > 0 || exit > 0);
  }

  return !!timeout;
};

exports.shouldAnimatePopover = shouldAnimatePopover;

var getArrowShift = function getArrowShift(shift, direction) {
  if (!shift && !isTestEnv) {
    return {};
  }

  if (direction.startsWith('top') || direction.startsWith('bottom')) {
    return {
      left: "".concat(shift, "px")
    };
  }

  if (direction.startsWith('left') || direction.startsWith('right')) {
    return {
      top: "".concat(shift, "px")
    };
  } // Arrow can't be shifted when using automatic positioning


  return {};
};

exports.getArrowShift = getArrowShift;
//# sourceMappingURL=utils.js.map